import { render, staticRenderFns } from "./DRSTBox.vue?vue&type=template&id=323e1774&"
import script from "./DRSTBox.vue?vue&type=script&lang=ts&"
export * from "./DRSTBox.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323e1774')) {
      api.createRecord('323e1774', component.options)
    } else {
      api.reload('323e1774', component.options)
    }
    module.hot.accept("./DRSTBox.vue?vue&type=template&id=323e1774&", function () {
      api.rerender('323e1774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTBox.vue"
export default component.exports